import FeaturedArticle from '../../components/noticias/FeaturedArticle';
import NoticiasGrid from '../../components/noticias/NoticiasGrid';
import Container from '../../components/shared/Container';
import PageHero from '../../components/shared/PageHero';
import { getExcerptListado } from '../../data/noticias';
import { useNoticiasPublicas } from '../../hooks/useNoticiasPublicas';
import { getDestacada } from '../../services/noticiasPublicas';
import styles from './NoticiasPage.module.css';

export default function NoticiasPage() {
  // Estaticas mas publicadas, ordenadas por fecha. Misma fuente que la seccion
  // de noticias del home, y al dia: si se publica algo desde el panel, el hook
  // vuelve a pedir el listado.
  const { datos: allNoticias } = useNoticiasPublicas();

  const featured = getDestacada(allNoticias);
  const rest = allNoticias.filter((noticia) => noticia.id !== featured?.id);

  return (
    <>
      <PageHero
        breadcrumb={[{ label: 'Inicio', to: '/' }, { label: 'Conócenos' }, { label: 'Noticias' }]}
        title="Noticias"
        subtitle="Actualidad de Solimat: compromiso, prevención, calidad y las personas en el centro de nuestra gestión."
      />

      {featured ? (
        <Container as="section" className={styles.featuredSection}>
          <FeaturedArticle
            to={`/noticias/${featured.id}`}
            image={featured.image}
            date={featured.date}
            title={featured.title}
            excerpt={getExcerptListado(featured)}
          />
        </Container>
      ) : null}

      <Container as="section" className={styles.gridSection}>
        <NoticiasGrid noticias={rest} />
      </Container>
    </>
  );
}
